import React from 'react';
import { Box, Divider, Flex, Text } from '@chakra-ui/react';
import { choiceSeparator } from 'studio_react/questionnaire/common';
import { useTranslate } from 'ts/common/hooks';

const ReadOnlyResponse: React.FC<{
    question: SpApi.Client.IQuestionnaireQuestion;
}> = ({ question }) => {
    const t = useTranslate('clientQuestionnaire');

    if (!question.responseText) {
        return (
            <Text color="gray.400" fontStyle="italic">
                {t('noResponse')}
            </Text>
        );
    }

    if (question.responseType === 'choices_checkboxes') {
        const selections = question.responseText.split(choiceSeparator);
        return (
            <Flex direction="column" gap="4px">
                {selections.map((selection, idx) => (
                    <Text key={idx}>{selection}</Text>
                ))}
            </Flex>
        );
    }

    return <Text whiteSpace="pre-wrap">{question.responseText}</Text>;
};

const QuestionnaireCompletedView: React.FC<{
    sortedPages: SpApi.Client.IQuestionnairePage[];
}> = ({ sortedPages }) => {
    return (
        <Flex direction="column" gap="32px">
            {sortedPages.map((page, pageIdx) => (
                <Flex key={page.id} direction="column" gap="16px">
                    <Text as="h3" fontSize="18px" fontWeight="600">
                        {page.name}
                    </Text>
                    {[...page.questions]
                        .sort((a, b) => a.displayOrder - b.displayOrder)
                        .map((question) => (
                            <Box
                                key={question.id}
                                paddingX={{ base: '16px', lg: '40px' }}
                                paddingY="8px"
                            >
                                <Text fontSize="16px" marginBottom="8px">
                                    {question.questionText}
                                </Text>
                                <ReadOnlyResponse question={question} />
                            </Box>
                        ))}
                    {pageIdx < sortedPages.length - 1 && <Divider />}
                </Flex>
            ))}
        </Flex>
    );
};

export default QuestionnaireCompletedView;
